// darwin_core's DSR sagas (dsr.js, pendingDsrCommands.js) carry a leftover
// `import { Auth } from 'aws-amplify'` — the Amplify v5 API, removed in v6. Both
// sagas only pass Auth into `jsonApi(Auth)`, and that factory (api/jsonapi.js)
// ignores its argument, so the value is silently discarded and no property is
// ever accessed on it. But v6's ESM has no `Auth` export, so the strict
// production bundler fails its named-export check without this binding. The
// Proxy makes any accidental future use fail loudly rather than behave subtly
// wrong.
export const Auth = new Proxy(
  {},
  {
    get() {
      throw new Error(
        'aws-amplify v5 `Auth` is not available on web; use aws-amplify/auth',
      );
    },
  },
);
